import type { ScreenerExchangeData } from '@/types'
import { formatFundingRate, fundingSnapshotDescription } from './fundingDisplay'

export function FundingRateBadge({ data }: { data?: Partial<ScreenerExchangeData> }) {
  const rate = data?.funding_rate
  const available = rate != null && Number.isFinite(rate)
  const color = !available || rate === 0 ? 'text-slate-300' : rate > 0 ? 'text-teal-300' : 'text-rose-300'
  return (
    <span title={fundingSnapshotDescription(data)} tabIndex={0}
      aria-label={`Current funding ${formatFundingRate(rate)}. ${fundingSnapshotDescription(data)}`}
      className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded border border-slate-700/60 bg-slate-950/60 px-1.5 py-0.5 text-[10px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-teal-300">
      <span className="text-slate-500">Current funding</span>
      <span className={`font-mono font-semibold ${color}`}>{formatFundingRate(rate)}</span>
    </span>
  )
}
